import openSocket from "socket.io-client";
import { isObject } from "lodash";
import SocketWorker from "./SocketWorker"

export function socketConnection(params) {
  let userId = "";
  let companyId = "";

  if (isObject(params)){
    // Suportar ambos os formatos: { user: { companyId, id } } e { companyId, userId }
    if (params.user) {
      companyId = params.user.companyId;
      userId = params.user.id;
    } else {
      companyId = params.companyId;
      userId = params.userId;
    }
  }

  // Validar se companyId e userId são válidos antes de criar o socket
  if (!companyId || !userId || companyId === 'undefined' || userId === 'undefined') {
    console.error('socketConnection: Parâmetros inválidos', { companyId, userId, params });
    return null;
  }

  try {
    return SocketWorker(companyId, userId);
  } catch (error) {
    console.error('socketConnection: Erro ao criar SocketWorker', error);
    return null;
  }
}